<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">微信下载记录</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>身份认证总状态：</label>
          <el-select v-model="overallAuthState" placeholder="Select" style="width: 7em">
            <el-option v-for="item in overallAuthStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>微信号认证：</label>
          <el-select v-model="wechatState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in wechatStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="注册时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
<!--          <el-button type="primary" v-loading="updateLoading" @click="updateInteract">标为已审查</el-button>-->
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            v-loading="listLoading"
            @sort-change="sortChange"
        >
<!--          <el-table-column type="selection" width="40" align="center" class-name="cursor"/>-->
          <el-table-column property="regTime" label="注册时间" v-if="checkColList.indexOf('注册时间') > -1" sortable='custom'/>
          <el-table-column label="用户信息" v-if="checkColList.indexOf('用户信息') > -1" width="200">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid"/>
            </template>
          </el-table-column>
          <el-table-column property="downloadTime" label="最新下载时间" v-if="checkColList.indexOf('最新下载时间') > -1" sortable='custom'/>
          <el-table-column property="downloadNum" label="总微信下载次数" v-if="checkColList.indexOf('总微信下载次数') > -1" class-name="cursor" sortable='custom'>
            <template #default="scope">
              <span style="color: #409eff">{{ scope.row.downloadNum}}次</span>
            </template>
          </el-table-column>
          <el-table-column property="regDay" label="注册至今时间" v-if="checkColList.indexOf('注册至今时间') > -1" sortable='custom'>
            <template #default="scope">
              <span>{{ scope.row.regDay}}天</span>
            </template>
          </el-table-column>
          <el-table-column property="chatViolationNum" label="总微信下载次数/注册至今时间" v-if="checkColList.indexOf('总微信下载次数/注册至今时间') > -1" sortable='custom' width="240">
            <template #default="scope">
              <span>{{ scope.row.everydayDownloadPct}}次/天</span>
            </template>
          </el-table-column>
          <el-table-column property="" label="微信号认证" v-if="checkColList.indexOf('微信号认证') > -1" >
            <template #default="scope">
              <span>{{scope.row.wechatState==0?'未提交':scope.row.wechatState==1?'待审核':scope.row.wechatState==2?'审核通过':scope.row.wechatState==3?'审核不通过':''}}</span>
            </template>
          </el-table-column>
          <el-table-column property="" label="身份认证总状态" v-if="checkColList.indexOf('身份认证总状态') > -1">
            <template #default="scope">
              <p>{{scope.row.identityAuth.overallAuthState == 0 ? "未提交" : scope.row.identityAuth.overallAuthState == 1 ? "待审核" : scope.row.identityAuth.overallAuthState == 2 ? "审核通过" : scope.row.identityAuth.overallAuthState == 3 ? "审核不通过" : ""}}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
<!--              <el-space direction="vertical" alignment="left">-->
<!--                <el-button v-if="!scope.row.isForbidden" type="primary" size="small" @click="updateUserForbidden(scope.$index, scope.row, 1)" v-loading="scope.row['forbiddenLoading']">封号</el-button>-->
<!--                <el-button v-if="scope.row.isForbidden" type="success" size="small" @click="updateUserForbidden(scope.$index, scope.row, 2)" v-loading="scope.row['forbiddenLoading']">解除封号</el-button>-->
<!--                <el-button v-if="!scope.row.isIdfaBan" type="primary" size="small" @click="updateUserIdfaBan(scope.$index, scope.row, 0)" v-loading="scope.row['isIdfaBanLoading']">冻结设备</el-button>-->
<!--                <el-button v-if="scope.row.isIdfaBan" type="success" size="small" @click="updateUserIdfaBan(scope.$index, scope.row, 1)" v-loading="scope.row['isIdfaBanLoading']">解除冻结</el-button>-->
<!--              </el-space>-->
              <ActionButton :row="scope.row" showList="forbidden,idfa"/>
            </template>
          </el-table-column>
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="180">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import ActionButton from "@/components/resume/ActionButton";
import {
  getWechatDownloadPageList,
  updateUserForbidden,
  updateUserIdfaBan
} from '@/api/url'
import {getFormData, postFormData} from '@/api/api'
import Dialog from '../../assets/js/dialog'
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import ImgViewer from '../../assets/js/imageViewer'
import {auth, common} from "@/assets/shared/select-constant";
import UserLog from "@/components/UserLog/UserLog";
import ForbiddenDialog from '@/components/resume/ForbiddenDialog'
import RecordListDialog from "@/views/wechat/components/RecordListDialog";

export default {
  name: "WeChatRecord",
  components: { DatePickerRange, SearchComponents, UserLog, ActionButton },
  data() {
    return {

      sexArray: common.sexList,
      sex: common.sexList[2]['value'],

      //身份认证总状态
      overallAuthStateArray: auth.overallAuthStateList,
      overallAuthState: auth.overallAuthStateList[3]['value'],

      //微信号认证
      wechatStateArray: [
        {label: '不限', value: -1},
        {label: '未提交', value: 0},
        {label: '待审核', value: 1},
        {label: '审核通过', value: 2},
        {label: '审核不通过', value: 3}
      ],
      wechatState: -1,

      //IM/纸条时间
      startTime: '',
      endTime: '',
      isChecked: false,

      //搜索
      searchType: '',
      searchValue: '',

      //刷新组
      colList: ['注册时间', '用户信息', '最新下载时间', '总微信下载次数', '注册至今时间', '总微信下载次数/注册至今时间', '微信号认证', '身份认证总状态', '操作', '用户日志'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

      dataSummary: [],

      idArray: [],
      updateLoading: false,

      sort: 1,

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = false;
      this.sex = -1;
      this.overallAuthState = 2;
      this.wechatState = -1;
      this.searchValue = '';
      this.sort = 1;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //排序
    sortChange(column) {
      if(column.prop == 'regTime') {
        if(column.order == 'descending') {
          this.sort = 1;
        } else if(column.order == 'ascending') {
          this.sort = 2;
        }
      } else if(column.prop == 'downloadTime') {
        if(column.order == 'descending') {
          this.sort = 3;
        } else if(column.order == 'ascending') {
          this.sort = 4;
        }
      } else if(column.prop == 'downloadNum') {
        if(column.order == 'descending') {
          this.sort = 5;
        } else if(column.order == 'ascending') {
          this.sort = 6;
        }
      } else if(column.prop == 'regDay') {
        if(column.order == 'descending') {
          this.sort = 1;
        } else if(column.order == 'ascending') {
          this.sort = 2;
        }
      } else if(column.prop == 'chatViolationNum') {
        if(column.order == 'descending') {
          this.sort = 7;
        } else if(column.order == 'ascending') {
          this.sort = 8;
        }
      }
      this.getPage();
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.userId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.userId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['overallAuthState'] = this.overallAuthState;
      param['wechatState'] = this.wechatState;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['sort'] = this.sort;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getWechatDownloadPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList: imgList
      })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

      //聊天人数
      if(column.label == '总微信下载次数') {
        Dialog.open({
          title: '总微信下载次数',
          component: RecordListDialog,
          data: {
            id: row.userId,
          },
          close: () => {

          }
        })
      }

    },

    //冻结设备
    updateUserIdfaBan(idx, row, state) {
      this.$confirm('确定' + (state == 0?'冻结':'解冻') + '用户' +'【' + row.nickName + '】的设备?').then(()=>{
        this.pageDataList[idx]['isIdfaBanLoading'] = true
        let param = {}
        param['id'] = row.userId
        param['state'] = state
        postFormData(updateUserIdfaBan, param).then((data)=>{
          let {code, msg} = data
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.pageDataList[idx]['isIdfaBan'] = state == 0?true:false
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.pageDataList[idx]['isIdfaBanLoading'] = false
        }).catch(()=>{
          this.pageDataList[idx]['isIdfaBanLoading'] = false
        })
      })
    },


    //更新封号状态
    updateUserForbidden(idx, row, state) {
      if(state == 1) {
        Dialog.open({
          title: '确定对用户【' + row.nickName + '】封号？',
          component: ForbiddenDialog,
          data: {
            userId: row.userId,
            width: '500px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      } else if(state == 2) {
        this.$confirm('确定【取消封号】用户' +'【' + row.nickName + '】?').then(()=>{
          this.pageDataList[idx]['forbiddenLoading'] = true
          let param = {}
          param['id'] = row.userId
          param['state'] = state
          param['type'] = 99
          param['idfaBanState'] = 0
          postFormData(updateUserForbidden, param).then((data)=>{
            let {code, msg} = data
            if(code == 200) {
              this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              })
              this.pageDataList[idx]['isForbidden'] = false
            }else {
              this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'warning'
              })
            }
            this.pageDataList[idx]['forbiddenLoading'] = false
          }).catch(()=>{
            this.pageDataList[idx]['forbiddenLoading'] = false
          })
        })
      }
    },

  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
